import { Close } from '@mui/icons-material';
import { Dialog, IconButton } from '@mui/material';
import './RolesInfoDialog.scss';

type RolesInfoDialogProps = {
  onClose: () => void;
};

export const RolesInfoDialog: React.FC<RolesInfoDialogProps> = ({
  onClose,
}) => (
  <Dialog open className="roles-info-dialog" onClose={onClose}>
    <div className="roles-info-header">
      <IconButton onClick={onClose}>
        <Close />
      </IconButton>
    </div>
    <div className="table-container">
      <table className="roles-info-table">
        <tr>
          <th>Role</th>
          <th>Permissions</th>
        </tr>
        <tr>
          <td rowSpan={5}>Project Admin</td>
          <td>Edit Project</td>
        </tr>
        <tr>
          <td>Conduct Inspection</td>
        </tr>
        <tr>
          <td>Log Observation</td>
        </tr>
        <tr>
          <td>Record Incident</td>
        </tr>
        <tr>
          <td>Approve / Disapprove Task</td>
        </tr>
        <tr>
          <td className="placeholder-cell" colSpan={2} />
        </tr>
        <tr>
          <td rowSpan={4}>Inspector</td>
          <td>Conduct Inspection</td>
        </tr>
        <tr>
          <td>Log Observation</td>
        </tr>
        <tr>
          <td>Record Incident</td>
        </tr>
        <tr>
          <td>Approve / Disapprove Task</td>
        </tr>
        <tr>
          <td className="placeholder-cell" colSpan={2} />
        </tr>
        <tr>
          <td rowSpan={2}>Doer</td>
          <td>Schedule Inspection</td>
        </tr>
        <tr>
          <td>Submit Task</td>
        </tr>
        <tr>
          <td colSpan={2}>
            * Doer is necessary to start any Inspection, Observation & Incident
            in any project
          </td>
        </tr>
      </table>
    </div>
  </Dialog>
);
